export default {
  sm: `
  NAVER's growth accompanied the 
  increase in data resulting from 
  changes in the IT service environment. 
  To provide stable services to NAVER 
  users and corporate cloud customers, 
  and to efficiently manage and store 
  increasing data, DATA CENTER GAK 
  has established GAK Chuncheon 
  in 2013 and GAK Sejong in 2023 
  to build and run a large-scale IT 
  infrastructure that can accommodate approximately 700,000 server units.
  `,
  lg: `
  NAVER's growth accompanied the increase in 
  data resulting from changes in the IT service 
  environment. To provide stable services to 
  NAVER users and corporate cloud customers, 
  and to efficiently manage and store increasing 
  data, DATA CENTER GAK has established GAK 
  Chuncheon in 2013 and GAK Sejong in 2023 to 
  build and run a large-scale IT infrastructure 
  that can accommodate approximately 700,000 
  server units. 
  `,
  xxl: `
  NAVER's growth accompanied the increase in data 
  resulting from changes in the IT service environment. To 
  provide stable services to NAVER users and corporate 
  cloud customers, and to efficiently manage and store 
  increasing data, DATA CENTER GAK has established GAK 
  Chuncheon in 2013 and GAK Sejong in 2023 to build and 
  run a large-scale IT infrastructure that can accommodate 
  approximately 700,000 server units.
  `,
};
